import { NgModule } from '@angular/core';
import { AuthService } from './auth.service';
import { ApiModule } from '../api/api.module';

@NgModule({
  imports: [ApiModule],
  providers: [AuthService],
})
export class AuthModule {}
